import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./SelectLanguage.module.css";
import Button from "../../component/Button";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { fetchDataFromApi } from "../../api/Api";
import languages from "./languages";

const SelectLanguage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  // const [languages, setLanguages] = useState([]);
  // const [selectedLang, setSelectedLang] = useState();
  const [selectedLang, setSelectedLang] = useState("en");

  const selectedLanguageObj = languages.find(
    (lang) => lang.langCode === selectedLang
  );
  
  const fetchLanguages = () => {
    // fetchDataFromApi("languages").then((res) => setLanguages(res));
  };

  const avatarId = location?.state?.uniqueIdNumber;
  const mobileId = location?.state?.mobile;
  // let welcomeMessage = [];

  const onButtonClick = () => {
    if (true) {
      navigate("/informationPage", { state: { avatarId, mobileId } });
    }
  };

  // const handleChange = (lang) => {
  //   i18next.changeLanguage(lang.value);
  //   localStorage.setItem("lang", lang.value);
  //   setSelectedLang(lang.selectedIndex);
  // };
  const handleChange = (e) => {
    const langCode = e.value;
    i18next.changeLanguage(langCode);
    localStorage.setItem("lang", langCode);
    setSelectedLang(langCode);
  };
  

  // useEffect(() => {
  //   // fetchLanguages();
  //   i18next.changeLanguage("en");
  //   localStorage.setItem("lang", "en");
  // }, []);
  useEffect(() => {
    const defaultLang = localStorage.getItem("lang") || "en";
    i18next.changeLanguage(defaultLang);
    setSelectedLang(defaultLang);
    localStorage.setItem("lang", defaultLang);
  }, []);
  

  return (
    <>
      <div className="container">
        <div className={styles.mainWrapper}>
          <p className={styles.headingText}>LANGUAGE</p>
          {/* <select
            id="language"
            className={styles.languageSelectBox}
            onChange={(e) => {
              handleChange(e.target);
            }}
          > */}
        <select
  id="language"
  className={styles.languageSelectBox}
  value={selectedLang}
  onChange={(e) => handleChange(e.target)}
>
  {languages.map((res) => (
    <option
      key={res.mlanguageId}
      value={res.langCode}
      className="text-center"
    >
      {res.langDisplay}
    </option>
  ))}
</select>

          {selectedLang ? (
            <p className={styles.notSelected}>SELECTED</p>
          ) : (
            <p className={styles.notSelected}>NOT SELECTED</p>
          )}

          <div className={styles.descWrapper}>
            <div className={styles.languageDescWrapper}>
              <p>
                {/* {languages[(selectedLang || 1) - 1]?.welcomeMessage} */}
                <p>{selectedLanguageObj?.welcomeMessage}</p>

              </p>
            </div>
          </div>
          <div className={styles.bottomButtonWrapper}>
            <Button
              text="START SURVEY"
              onClick={onButtonClick}
              // disabled={selectedLang ? false : true}
              disabled={!selectedLang}

            />
          </div>
        </div>
         {/* Footer */}
      <div className={styles.footerStrip}>
        Powered by Swachh Bharat Mission Urban
      </div>
      </div>
      
    </>
  );
};

export default SelectLanguage;
